import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { buildDeviceInventoryCountQueryParams, getDeviceInventoryCount, SearchSchema } from '@/features/device/inventory';
export const Route = createFileRoute('/_staff/device-catalog/active/$id/_layout/inventories/')({
  validateSearch: zodValidator(SearchSchema),
  loader: ({
    params
  }) => getDeviceInventoryCount(buildDeviceInventoryCountQueryParams(params.id))
});